import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment/moment";

export var groupCountDataRes;
export const groupCountDataTodo = createAsyncThunk('groupCountData', async (ids) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'master/view_group_data',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "group_ids": ids,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return groupCountDataRes = res.data
    } catch (error) {
        return groupCountDataRes = error.response.data
    }
})


const groupCountDataSlice = createSlice({
    name: 'groupCountData',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(groupCountDataTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('groupCountData', state.data)
            }
        });
        builder.addCase(groupCountDataTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default groupCountDataSlice.reducer; 